import Layout from 'common/Layout';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRouter = () => {
  const isLoggedIn = useSelector((state) => state.user.response) && localStorage.getItem('user');
  const redirectTo = location.pathname == '/userlogin' ? '/userlogin' : '/signin';
  return (
    <div>
      {isLoggedIn ? (
        <Layout>
          <Outlet />
        </Layout>
      ) : (
        <Navigate to={redirectTo} replace state={{ from: location.pathname }}/>
      )}
    </div>
  );
};
export default PrivateRouter;